export default "__VITE_ASSET__CbKf0M$a__"